<template>
  <div id="serviceType">
    <div id="service">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class Service extends Vue {}
</script>

<style scoped lang="scss">
#serviceType {
  background-color: #F6F7F9;
  padding-bottom: 50px;
  #service {
    width: 1572px;
    padding-top: 20px;
    margin: auto;
    min-height: calc(100vh - 590px);
  }
}
</style>
